<template>
	<div>
		<header-page :title="title" />
		<accounting-rule-form :id="id" />
	</div>
</template>

<script>
	import accountingRuleForm from '@/components/accounting-rules/accounting-rule-form';

	function title() {
		const { name } = this.$route.query;
		return `${name} / ${this.$route.meta.title}`;
	}

	export default {
		name: 'accounting-rule-new',
		components: {
			accountingRuleForm,
		},
		computed: {
			title,
		},
		props: {
			id: [Number, String],
		},
	};
</script>



// WEBPACK FOOTER //
// src/pages/accounting-rules/page-accounting-rule-new.vue